$(function () {
    $('.right-pagination .gotonum').on('keydown', function (event) {
        if (event.keyCode == '13') {
            var page = $.trim($(this).val());
            if (page.length == 0) {
                return;
            }

            var size = $(this).data('size');
            var url = $(this).data('url');
            var query = $(this).data('query');
            location.href = url + '?page=' + page + '&size=' + size + query;
        } else if (!(event.keyCode == 46) && !(event.keyCode == 8) && !(event.keyCode == 37) && !(event.keyCode == 39)) {
            if (!((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105))) {
                event.preventDefault();
            }
        }
    });

    $('.right-pagination .selectsize').on('changed.bs.select', function (event) {
        var size = $('.right-pagination .selectsize').selectpicker('val');
        size = parseInt(size);
        var oldSize = $('.right-pagination .gotonum').data('size');
        oldSize = parseInt(oldSize);

        if (size == oldSize) {
            return;
        }

        var page = $($('.right-pagination .pagechoose')).text();
        var url = $('.right-pagination .gotonum').data('url');
        var query = $('.right-pagination .gotonum').data('query');
        var href = url + '?page=' + page + '&size=' + size + query;
        location.href = href;
    });
});